import { Ref, computed } from 'vue';
import { InitialPublicOfferItem } from '@libs/api-reference';

import { BEFORE_END_PRE_ORDER } from '../constants';

type UseBeforeEndPreOrderType = {
  offer: InitialPublicOfferItem;
  hasPurchase: Ref<boolean>;
  hasPrice: boolean;
};

export default function useBeforeEndPreOrder({
  offer,
  hasPurchase,
  hasPrice,
}: UseBeforeEndPreOrderType) {
  const flow = computed(() => {
    if (offer.hasPreOrder) {
      if (hasPrice) {
        if (hasPurchase.value) {
          return 'flow1';
        }

        return 'flow2';
      }

      return 'flow3';
    }

    if (offer.isAutomaticSubmit) {
      if (hasPrice) {
        if (hasPurchase.value) {
          return 'flow4';
        }

        return 'flow5';
      }

      return 'flow6';
    }

    if (hasPrice) {
      return 'flow7';
    }

    return 'flow8';
  });

  return {
    time: offer.allowingSubmittingPreOrderUntilDateTime,
    stylesConfig: BEFORE_END_PRE_ORDER[flow.value],
  };
}
